import React from 'react';
import ReactModal from 'react-modal';
import Classnames from 'classnames';
import { GlobalModalProps } from '../types';
import { ListModalLayout } from '../../ui-layouts';

import './list-modal.scss';

interface ListModalProps extends GlobalModalProps {
    hasExitButton?: boolean;
    header?: JSX.Element;
}

export const ListModal: React.FC<ListModalProps> = ({
    ariaDescribedById,
    ariaLabelledById,
    contentLabel,
    customClassName,
    customOverlayClassName,
    hasExitButton = true,
    header,
    isOpen,
    onClose,
    children,
}): React.ReactElement => {
    const className: string = Classnames('modal list-modal z-index-modal-full', customClassName);
    const overlayClassName: string = Classnames('overlay z-index-overlay-full', customOverlayClassName);

    return (
        <ReactModal
            aria={{
                describedby: ariaDescribedById,
                labelledby: ariaLabelledById,
            }}
            ariaHideApp={false}
            contentLabel={contentLabel}
            className={className}
            overlayClassName={overlayClassName}
            isOpen={isOpen}
            onRequestClose={onClose}
            testId={className}
        >
            <ListModalLayout hasExitButton={hasExitButton} header={header} onClose={onClose}>
                {children}
            </ListModalLayout>
        </ReactModal>
    );
};
